import _ from "lodash";
import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

export default function OrderCharts({ data }) {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (data && data.totalFilter) {
      getChartData(data.totalFilter);
    }
  }, [data]);

  const getChartData = (orders) => {
    setOptions({
      chart: {
        fontFamily: "FontLao2",
        id: "",
        toolbar: {
          show: false,
        },
        fill: {
          colors: ["#592375"],
        },
      },
      xaxis: {
        categories: orders.map((day) => {
          return day.name;
        }), // will be displayed on the x-axis
      },
    });
    setSeries([
      {
        name: "ຈຳນວນມື້ນີ້", // will be displayed on the y-axis
        data: orders.map((day) => {
          return parseInt(day.amount, 10);
        }),
      },
    ]);
  };

  // if(_.isEmpty(data)) return <div style={{width:'100%', height:315}}>
  //   <img src="https://static.vecteezy.com/ti/vecteur-libre/p1/5006029-le-processus-termine-le-paquet-de-commande-est-arrive-avec-une-notification-pour-smartphone-concept-illustration-flat-design-vector-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographie-vectoriel.jpg" />
  // </div>

  return (
    <div>
      <Chart
        options={options}
        type="bar"
        series={series}
        width="100%"
        height="315px"
      />
    </div>
  );
}